module.exports = __webpack_public_path__ + "img/120.a6e2c8a6.jpg";